const directoryPaths = new Set(['/users', '/subscriptions', '/services', '/applications', '/login-origins', '/login-result-pages', '/content']);

// 位置只保存在当前文档，随管理上下文整页离开而销毁。
export function createAdminScrollBehavior(readPosition) {
  const positions = new Map();
  const scrollBehavior = (to, from, savedPosition) => {
    if (savedPosition) return savedPosition;
    if (to.path === from.path) return false;
    return positions.get(to.path) || { left: 0, top: 0 };
  };
  // 必须在导航守卫中调用，页面替换后短骨架可能已经裁切 window.scrollY。
  scrollBehavior.remember = route => {
    if (directoryPaths.has(route.path)) positions.set(route.path, { ...readPosition() });
  };
  return scrollBehavior;
}
